<section>
    <h2>Create new Project</h2>
    <app-vca-filter [pageId]="pageId" [userInfos]="userInfos" [modes]="modes" (filterDataOutputEvent)="loadSplitContentData($event)">
    </app-vca-filter>
    <app-project-creation [userInfos]="userInfos" [data]="dataSource" [platformInfos]="platformInfos"></app-project-creation>
</section>